<template>
  <cs-preloader-overlay :loading="loading" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PaymentOrigin',
  created() {
    this.loadPaymentOrigin();
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters([
      'getPaymentId',
      'getProcessToken',
      'getPaymentOrigin',
    ]),
  },
  methods: {
    async loadPaymentOrigin() {
      if (this.$validate.isUndefined(this.getPaymentId) || this.$validate.isNull(this.getPaymentId)) {
        this.$router.push({ name: 'service.error' });
        return;
      }

      if (this.$validate.isUndefined(this.getProcessToken) || this.$validate.isNull(this.getProcessToken)) {
        this.$router.push({ name: 'service.error' });
        return;
      }

      try {
        await this.GET_PAYMENT_ORIGIN(this.getPaymentId);

        const { redirect, origin } = this.getPaymentOrigin;

        if (redirect) {
          window.location.assign(`${origin}/pending?paymentId=${this.getPaymentId}&processToken=${this.getProcessToken}`);
          return;
        }

        this.$router.push({
          name: 'pending.payment',
          query: {
            paymentId: this.getPaymentId,
            processToken: this.getProcessToken,
          },
        });
      } catch (error) {
        console.log(error);
        this.$router.push({ name: 'service.error' });
      }
    },
    ...mapActions(['GET_PAYMENT_ORIGIN']),
  },
};
</script>
